import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Feature } from '@meeting-assistant/schemas';
import { useFlag } from '@/lib/features/FeatureProvider';
import { configQueryOptions } from '@/lib/query/configQuery';
import { templateQueryOptions } from '@/lib/query/templatesQuery';
import { TemplateEditor } from '@/components/templates/TemplateEditor';

export const Route = createFileRoute('/templates_/$templateId/edit')({
  component: TemplateEditorRoute,
});

function TemplateEditorRoute() {
  const { templateId } = Route.useParams();
  const { isPending } = useQuery(configQueryOptions);
  const enabled = useFlag(Feature.CUSTOM_TEMPLATE_ENABLED);
  const { data: template } = useQuery({
    ...templateQueryOptions(templateId),
    enabled: !isPending && enabled,
  });

  if (isPending) return null;
  if (!enabled) return <Navigate to="/" />;
  if (!template) return null;

  return <TemplateEditor key={templateId} template={template} />;
}
